import EducationFairForm, { educationFairFormSchema } from './EducationFairForm'

export default EducationFairForm
export { educationFairFormSchema }
